<template>
  <component
    :is="publication?.menu_url ? NuxtLink : 'div'"
    v-if="publication"
    :to="publication?.menu_url ? localePath(publication.menu_url) : undefined"
    class="flex w-full flex-col items-center gap-5 transition-transform duration-100"
    :class="{ 'hover:scale-[1.02]': publication?.menu_url }"
  >
    <div
      class="mx-auto flex aspect-4/5 w-full max-w-55 items-center justify-center md:max-w-66"
    >
      <NuxtImg
        v-if="publication?.image?.url"
        :src="publication.image.url"
        :alt="publication?.image?.alt_text || publication.title + 'image'"
        :loading="eager ? 'eager' : 'lazy'"
        format="webp"
        sizes="xs:220px md:264px"
        class="h-auto max-h-full w-auto max-w-full object-contain shadow-[0_4.059px_18.266px_rgba(0,0,0,0.1)] md:shadow-[0_5px_22px_rgba(0,0,0,0.1)] min-[1680px]:shadow-[0_5.833px_25.667px_rgba(0,0,0,0.1)]"
      />
      <NuxtImg
        v-else
        src="https://placehold.co/600x750"
        :alt="publication.title + 'image'"
        :loading="eager ? 'eager' : 'lazy'"
        format="webp"
        sizes="xs:220px md:264px"
        class="h-auto max-h-full w-auto max-w-full object-contain shadow-[0_4.059px_18.266px_rgba(0,0,0,0.1)] md:shadow-[0_5px_22px_rgba(0,0,0,0.1)] min-[1680px]:shadow-[0_5.833px_25.667px_rgba(0,0,0,0.1)]"
      />
    </div>

    <div
      class="flex flex-col items-center text-center text-sm/[115%] xl:text-sm/[115%]"
      :class="[
        publication?.menu_url
          ? 'max-w-62.5 md:max-w-75 xl:w-75! xl:max-w-max! 2xl:w-87.5!'
          : 'max-w-62.5 md:max-w-75',
      ]"
    >
      <p>{{ publication.title }}</p>
      <div v-if="publication.description" v-html="publication.description" />
    </div>
  </component>
</template>

<script setup lang="ts">
import type { Publication } from '~/types'

interface Props {
  publication: Publication
  eager?: boolean
}

const props = defineProps<Props>()

const localePath = useLocalePath()
const NuxtLink = resolveComponent('NuxtLink')
</script>
